import axiosInstance from '@/axiosInstance'
import Org from '@/structs/Org'
import User from '@/structs/User'

const actions = {
  update ({ commit }, org) {
    if (!org || !(org instanceof Org)) {
      throw Error(`Invalid org - ${org}`)
    }

    // should be POST
    return axiosInstance.post(
      process.env.BASE_URL + 'api/?mode=ORG&action=UPDATE',
      org
    ).then(response => {
      const org = Object.assign(new Org(), response.data.org)

      // commit to the auth store
      commit('auth/SET_AUTH_ORG', org, { root: true })
    })
  },
  fetchUsers () {
    return new Promise((resolve, reject) => {
      return axiosInstance.get(
        process.env.BASE_URL + 'api/?mode=ORG&action=USERS'
      ).then(response => {
        const users = (response.data.users || []).map(user => { return Object.assign(new User(), user) })

        resolve(users)
      }).catch((err) => { reject(err) })
    })
  },
  findByWebsite (_, { website }) {
    return new Promise((resolve, reject) => {
      return axiosInstance.post(
        process.env.BASE_URL + 'api/?mode=ORG&action=FINDBYWEBSITE',
        { website: website }
      ).then(response => {
        const org = Object.assign(new Org(), response.data.org)

        resolve(org)
      }).catch((err) => { reject(err) })
    })
  },
  fetchOrgApps ({ commit }) {
    return new Promise((resolve, reject) => {
      return axiosInstance.get(
        process.env.BASE_URL + 'api/?mode=APPS&action=LOAD&orgapps=true'
      ).then(response => {
        if (response.data.apps && response.data.apps.length > 0) {
          resolve(response.data.apps)
        } else {
          resolve([])
        }
      }).catch((err) => { reject(err) })
    })
  }
}

export default {
  namespaced: true,
  actions
}
